import React from "react";
import { Tooltip } from "antd";

interface Props {
  logo?: string;
  description?: string;
  className?: string;
}

export default function BrandLogoBadge({ logo, description, className = "v2-offer-card__brand" }: Props) {
  if (!logo) return null;

  const badge = <img className={className} src={logo} alt="Brand" />;

  return description ? (
    <Tooltip title={description} color="#484954">
      {badge}
    </Tooltip>
  ) : badge;
}
